export const sanitizeProductNumber = (productNo: string): string => {
    let variationStartIndex = productNo.indexOf("/");
    
    if (variationStartIndex == -1) {
        return productNo;
    }

    let baseProductNo = productNo.slice(0, variationStartIndex);
    return baseProductNo;
}